import React, { Fragment } from "react";
import Grid from '@mui/material/Grid';
import Header from "./header";


export default function RecipeList() {

return (
    <Fragment>
        <Header/>
        <Grid  sx={{margin: '2rem'}}>
                        <h1>Our Values</h1>
                        <h3>Inclusivity</h3><span>Share your experience quicker and easier with everyone.</span>

                        <h3>Convenient</h3><span>Let us pick the best options for you and your peers!
                </span>

                        <h3>Variety</h3><span>We have diverse options, all healthy and appetizing.</span>

                        <h3>Sustainable</h3><span>What grows where and how it is grown are a matter of choice and careful consideration for nature and communities.
                </span>

                        <h3>Free for all</h3><span>We want to truly empower the communities and bring us all closer together through deep understanding.</span>
        </Grid>
    </Fragment>
  );
}